import React from 'react';
import {Link} from 'react-router';
import If from './If';
import SoldOutBox from './SoldOutBox';
import PriceInfoBox from './PriceInfoBox';
import ExcursionDuration from './ExcursionDuration';
import ExcursionAttributes from './ExcursionAttributes';
import {getResourceImageUrl} from '../actions/networkActions';
import CenteredImageContainer from './CenteredImageContainer';
import BookingCode from "./BookingCode";
import DepartureTime from "./DepartureTime";
import { Trans, useLingui } from '@lingui/react/macro';
import { getTranslation } from '../utils/translationUtils';

const ExcursionEntry = (props) => {

    const {t} = useLingui();
    const containerClasses = "bg-white border border-primary flex flex-wrap" + (props.first === true ? "" : " mt-8");
    const excursionLink = t({id:"/excursion"}) + `/${props.itinerary}/${props.id}`;
    const priceBoxDivClasses = `${props.currentAvailability > 0 ? "w-1/2" : "w-full"} sm:w-1/3 xl:w-1/4 self-end py-4 px-2 sm:px-4`;

    return (
        <div className={containerClasses}>
            <div className="w-full sm:w-1/3 p-2 sm:p-4">
                <CenteredImageContainer
                    alt="excursion preview"
                    src={getResourceImageUrl(props.id, {width: 400, category: "cruiseExcursion"})}
                />
            </div>

            <div className="w-1/2 sm:w-1/3 xl:grow px-2 sm:px-0 pb-4 sm:pt-4 flex flex-col">
                <Link className="text-primary underline text-2xl uppercase" to={excursionLink}>
                    {getTranslation(props.name)}
                </Link>

                <ExcursionAttributes attributes={props.excursionTypes} />

                <div className="text-primary mt-2">
                    <BookingCode bookingCode={props.bookingCode} />
                    <DepartureTime fromTime={props.fromTime} endTime={props.toTime} />
                </div>

                <ExcursionDuration duration={props.duration} />

            </div>

            <div className={priceBoxDivClasses}>
                <If test={props.currentAvailability <= 0 || props.waitlistActivated}>
                    <SoldOutBox
                        isBookingAllowed={props.bookableForPassenger}
                        waitlistActivated={props.waitlistActivated}
                        currentWaitlistAvailability={props.currentWaitlistAvailability}
                    />
                    <Link className="block w-full action-button action-button-enabled mt-4" to={excursionLink}>
                        <Trans id="more_details">More details</Trans>
                    </Link>
                </If>

                <If test={props.currentAvailability > 0 && !props.waitlistActivated}>
                    <PriceInfoBox
                        classes="w-full text-primary-dark float-right"
                        adultPrice={props.price.adult}
                        childPrice={props.price.child}
                        currencySymbol={props.price.currencySymbol}
                        minimumAge={props.minimumAge}
                        buttonText={t({id: "more_details"})}
                        buttonIsLink={true}
                        linkTo={excursionLink}
                        currentAvailability={props.currentAvailability}
                    />
                </If>
            </div>
        </div>
    );
};

export default ExcursionEntry;